{
  "logoAlt": "Smart Word Labs",
  "footer": {
    "copyright": "© {{year}} Smart Word Labs · {{tagline}}"
  },
  "breadcrumb": {
    "home": "首页",
    "ariaLabel": "面包屑导航"
  },
  "notifications": {
    "ariaLabel": "通知",
    "unreadMore": "9+",
    "title": "提醒",
    "markRead": "标记为已读",
    "new": "新",
    "empty": "暂无提醒。",
    "error": "无法更新通知"
  },
  "mobileCta": {
    "bookFreeAssessment": "预约免费测评"
  }
}
